var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tc-video-player-box",
      style: { transform: `scale(${_vm.autoScale ? _vm.screenScale : 1})` },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.isMatchDayEnding && _vm.streamUrl && !_vm.videoPlayerReady,
              expression: "!isMatchDayEnding && streamUrl && !videoPlayerReady",
            },
          ],
          staticClass: "video-wrapper",
        },
        [_c("VideoLoadingOverlay", { attrs: { variant: "placeholder" } })],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.isMatchDayEnding && _vm.streamUrl && _vm.videoPlayerReady,
              expression: "!isMatchDayEnding && streamUrl && videoPlayerReady",
            },
          ],
          ref: "videoPlayerContainer",
          staticClass: "video-wrapper",
        },
        [
          _c(
            "div",
            {
              key: _vm.videoPlayerKey,
              staticClass: "video-player-key-wrapper",
            },
            [
              _c("video", {
                class: { isLarger: _vm.screenScale > 1 },
                attrs: {
                  id: _vm.playerDomId,
                  "webkit-playsinline": "true",
                  "x-webkit-airplay": "true",
                  playsinline: "",
                  allowfullscreen: "true",
                  webkitallowfullscreen: "true",
                  mozallowfullscreen: "true",
                  "x5-video-player-type": "h5",
                  "x5-video-player-fullscreen": "true",
                  options: _vm.playerOptions,
                },
                on: {
                  play: function ($event) {
                    return _vm.onPlayerPlay($event)
                  },
                  pause: function ($event) {
                    return _vm.onPlayerPause($event)
                  },
                  ended: function ($event) {
                    return _vm.onPlayerEnded($event)
                  },
                  loadeddata: function ($event) {
                    return _vm.onPlayerLoadeddata($event)
                  },
                  waiting: function ($event) {
                    return _vm.onPlayerWaiting($event)
                  },
                  playing: function ($event) {
                    return _vm.onPlayerPlaying($event)
                  },
                  timeupdate: function ($event) {
                    return _vm.onPlayerTimeupdate($event)
                  },
                  canplay: function ($event) {
                    return _vm.onPlayerCanplay($event)
                  },
                  canplaythrough: function ($event) {
                    return _vm.onPlayerCanplaythrough($event)
                  },
                  statechanged: function ($event) {
                    return _vm.playerStateChanged($event)
                  },
                },
              }),
            ]
          ),
          _vm.watermarkVisible &&
          _vm.streamWatermarkData &&
          _vm.streamWatermarkData.watermarkType === 1 &&
          _vm.streamWatermarkData.watermark
            ? _c(
                "div",
                {
                  staticClass: "video-layers",
                  class: `movement-${_vm.watermarkMovementType}`,
                  style: _vm.watermarkStyle,
                },
                [_vm._v(" " + _vm._s(_vm.streamWatermarkData.watermark) + " ")]
              )
            : _vm._e(),
          _vm.watermarkVisible &&
          _vm.streamWatermarkData &&
          _vm.streamWatermarkData.watermarkType === 2 &&
          _vm.streamWatermarkData.watermarkImageUrl
            ? _c("img", {
                staticClass: "video-layers video-layers-image",
                class: `movement-${_vm.watermarkMovementType}`,
                style: _vm.watermarkStyle,
                attrs: { src: _vm.getWatermarkImageUrl(), alt: "watermark" },
              })
            : _vm._e(),
          _vm.watermarkVisible &&
          _vm.streamWatermarkData &&
          _vm.streamWatermarkData.watermarkType === 5 &&
          _vm.streamWatermarkData.watermark
            ? _c(
                "div",
                {
                  staticClass: "video-layers",
                  class: `movement-${_vm.watermarkMovementType}`,
                  style: _vm.watermarkType5Style,
                },
                [_vm._v(" " + _vm._s(_vm.streamWatermarkData.watermark) + " ")]
              )
            : _vm._e(),
          _vm.watermarkVisible &&
          _vm.streamWatermarkData &&
          _vm.streamWatermarkData.watermarkType === 4 &&
          _vm.streamWatermarkData.watermark
            ? _c(
                "div",
                {
                  staticClass: "video-layers",
                  class: `movement-${_vm.watermarkMovementType}`,
                  style: _vm.watermarkStyle,
                },
                [_vm._v(" " + _vm._s(_vm.streamWatermarkData.watermark) + " ")]
              )
            : _vm._e(),
          _vm.streamWatermarkData &&
          (_vm.streamWatermarkData.watermarkType === 3 ||
            _vm.streamWatermarkData.watermarkType === 4) &&
          _vm.streamWatermarkData.watermark
            ? _c(
                "div",
                {
                  staticClass: "robust-watermark-overlay",
                  style: _vm.robustWatermarkOverlayStyle,
                },
                [_vm._v(" " + _vm._s(_vm.streamWatermarkData.watermark) + " ")]
              )
            : _vm._e(),
          _vm.isMobile && (_vm.isPullingToRefresh || _vm.isRefreshingStream)
            ? _c("div", { staticClass: "pull-refresh-overlay" }, [
                _c(
                  "div",
                  {
                    staticClass: "pull-refresh-icon",
                    class: {
                      "is-refreshing": _vm.isRefreshingStream,
                      "is-ready":
                        !_vm.isRefreshingStream &&
                        _vm.pullDistance >= _vm.pullRefreshThreshold,
                    },
                    style: {
                      transform: `translateY(${
                        _vm.isRefreshingStream
                          ? 0
                          : Math.min(
                              _vm.pullDistance,
                              _vm.pullRefreshThreshold * 1.2
                            )
                      }px)`,
                      opacity: _vm.isRefreshingStream
                        ? 1
                        : Math.min(
                            _vm.pullDistance / _vm.pullRefreshThreshold,
                            1
                          ),
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("polyline", {
                          attrs: { points: "23 4 23 10 17 10" },
                        }),
                        _c("path", {
                          attrs: { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" },
                        }),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._t("overlay"),
        ],
        2
      ),
      !_vm.streamUrl
        ? _c(
            "div",
            { staticClass: "no-active-arena" },
            [
              !_vm.streamError
                ? _c("img", {
                    staticClass: "logo",
                    attrs: { src: require("@/assets/images/alert.webp") },
                  })
                : _c("img", {
                    staticClass: "logo-out-of-balance",
                    attrs: { src: require("@/assets/images/out-of-money.png") },
                  }),
              _vm.streamError
                ? [
                    _c("div", { staticClass: "text my-3" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Stream locked")) + " "),
                    ]),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.convertStreamErrorMessage(_vm.streamError)
                          ) +
                          " "
                      ),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("No fight at the moment")) + " "
                      ),
                    ]),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Please come back again")) + " "
                      ),
                    ]),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm.isMatchDayEnding
        ? _c("div", { staticClass: "no-active-arena match-day-ending" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: require("@/assets/images/alert.webp") },
            }),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.$t("This arena has ended")) + " "),
            ]),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.$t("Thank you for your support")) + " "),
            ]),
          ])
        : _vm._e(),
      !_vm.embedded
        ? _c(
            "div",
            {
              class: [
                "video-banner-wrapper",
                { "is-mobile": _vm.isMobile, reverse: _vm.isReverse },
              ],
            },
            [
              _c("div", { staticClass: "odds-wrapper" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("Banker")))]),
                _vm.autoScale && _vm.screenScale > 1
                  ? _c("span", { staticClass: "ml-16 odds" }, [
                      _vm._v(_vm._s(_vm.bankerOdds)),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "odds-wrapper" }, [
                _vm.autoScale && _vm.screenScale > 1
                  ? _c("span", { staticClass: "mr-16 odds" }, [
                      _vm._v(_vm._s(_vm.playerOdds)),
                    ])
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.$t("Player")))]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }